
export const regExPattern = {
  phone: "^[0-9]{10}$",
  whatsapp_no : "^[0-9]{10}$",
  // teliphone : "^[0-9]{10}$",
  // email: "^[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}$",
  // email:"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$",
  email:"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$",
  name: "^(?! )(?!.* {2}).{2,}$",
  pinCode: "^[0-9]{0,}$",
  gstNo: "^[a-zA-Z0-9]{0,}$",
  password: "^[a-zA-Z0-9.,@#_ ]{6,}$",
  quantity: "^[0-9]{0,}$",
  amount:"^[0-9]{0,}$",
  // tel:"^[0-9/-]{0,}$",
};
